import React, {useEffect, useState} from 'react';
import ListReference from "./ListReference";

const LoadLinkData = ({formedName, boxhead="boxhead", boxbody="boxbody", boxlist="boxbodylist"}) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        fetch(formedName)
            .then(response => response.json())
            .then(data => setData(data))
            .catch(error => console.error('Error fetching data:', error));
    }, [formedName]);

    if (!data) {
        return (<>
            <div className={boxhead}>
                <h2>Loading...</h2>
            </div>
            <div className={boxbody}>
            </div>
        </>)
    }

    return (<>
        <div className={boxhead}>
            <h2>{data.heading}</h2>
        </div>
        <div className={boxbody}>
            <ul className={boxlist}>
                {data.items.map(item => (<ListReference listItem={item}/>))}
            </ul>
        </div>
    </>);
};

export default LoadLinkData;